import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import { containerQueries } from './AssetListItem';
import { assetListItemMenuAreaClasses } from './classNames';

export const AssetListItemMenuArea = ({ sx, onClick, ...rest }: BoxProps) => (
	<Box
		// prevent following the link of ListItemButton in AssetListItem
		onClick={(event) => {
			event.preventDefault();
			event.stopPropagation();
			onClick?.(event);
		}}
		className={assetListItemMenuAreaClasses.root}
		sx={combineSx(
			{
				gridArea: 'menu',
				alignSelf: {
					[containerQueries[0]]: 'start',
					[containerQueries[820]]: 'center',
				},
			},
			sx,
		)}
		{...rest}
	/>
);

export default AssetListItemMenuArea;
